'use client';

import { useLocale } from "next-intl";
import useSWR from "swr";

const fetcher = async <T>(url: string): Promise<T> => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Failed to fetch data. Please try again later.");
  }
};

interface Post {
  id: number;
  title_en: string;
  title_ar: string;
  title_fr: string;
  title_de: string;
  title_es: string;
  title_it: string;
  title_pt: string;
  title_nl: string;
  title_ru: string;
  title_sv: string;
  image_en: string;
  image_ar: string;
  image_fr: string;
  image_de: string;
  image_es: string;
  image_it: string;
  image_pt: string;
  image_nl: string;
  image_ru: string;
  image_sv: string;
  description_en: string;
  description_ar: string;
  description_fr: string;
  description_de: string;
  description_es: string;
  description_it: string;
  description_pt: string;
  description_nl: string;
  description_ru: string;
  description_sv: string;
}


const useFetchPosts = () => {
  const locale = useLocale();

  const { data, error, isLoading } = useSWR<Post[]>(
    [`${process.env.NEXT_PUBLIC_URL}post/`, locale],
    ([url]) => fetcher<Post[]>(url),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
      keepPreviousData: true,
    }
  );

  return { posts: data || [], error, isLoading: isLoading && !data };
};

export default useFetchPosts;